const VERSION_RE = /^(\d+)\.(\d+)\.(\d+)$/;

export function isValidVersion(value: unknown): value is string {
  return typeof value === "string" && VERSION_RE.test(value);
}

function parts(version: string): [number, number, number] {
  const m = VERSION_RE.exec(version);
  if (!m) return [0, 0, 0];
  return [Number(m[1]), Number(m[2]), Number(m[3])];
}

/** Orden semántico: negativo si a < b, 0 si iguales, positivo si a > b. */
export function compareVersions(a: string, b: string): number {
  const [a1, a2, a3] = parts(a);
  const [b1, b2, b3] = parts(b);
  return a1 - b1 || a2 - b2 || a3 - b3;
}
